/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { DateTime, Settings } from 'luxon';
import React, { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';

export const HULocalizationProvider = memo<{ children: React.ReactNode }>(props => {
  const { children } = props;
  const { i18n } = useTranslation();

  useEffect(() => {
    Settings.defaultLocale = i18n.language;
  }, [i18n.language]);

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon} dateLibInstance={DateTime} adapterLocale={i18n.language}>
      {children}
    </LocalizationProvider>
  );
});
